var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1707482024"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 33592",
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white",
    stroke: "#E5E5EC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1707481916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 33699",
    d: "M10.5 14.8287C10.5 14.0139 11.0898 13.3273 11.9009 13.2505C13.128 13.1344 15.161 13.0001 18 13C20.8392 12.9999 22.8723 13.1343 24.0993 13.2504C24.9104 13.3272 25.5 14.0137 25.5 14.8284V14.8879C25.5 15.8812 24.6363 16.6584 23.6461 16.5794C22.2046 16.4643 20.1023 16.3333 18 16.3333C15.8977 16.3333 13.7954 16.4643 12.3539 16.5794C11.3637 16.6584 10.5 15.8812 10.5 14.8879V14.8287Z",
    stroke: "#111111",
    strokeWidth: 1.66667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 33700",
    d: "M11.3333 16.75C11.3333 16.75 14.25 16.3333 18 16.3333C21.75 16.3333 24.6666 16.75 24.6666 16.75C24.6666 16.75 25.0833 18 25.0833 20.9167C25.0833 22.5267 24.8294 23.7558 24.6019 24.534C24.4247 25.1399 23.8512 25.5 23.2199 25.5H12.78C12.1487 25.5 11.5752 25.1399 11.3981 24.534C11.1705 23.7558 10.9166 22.5267 10.9166 20.9167C10.9166 18 11.3333 16.75 11.3333 16.75Z",
    stroke: "#111111",
    strokeWidth: 1.66667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 768",
    d: "M18 13V25.5",
    stroke: "#111111",
    strokeWidth: 1.66667
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3336 9.66659C14.9529 9.66659 13.8336 10.7859 13.8336 12.1666C13.8336 12.4588 13.8837 12.7393 13.9759 12.9999H16.3336H18.6914C18.7835 12.7393 18.8336 12.4588 18.8336 12.1666C18.8336 10.7859 17.7143 9.66659 16.3336 9.66659ZM16.3336 12.9999C16.7939 12.9999 17.167 12.6268 17.167 12.1666C17.167 11.7064 16.7939 11.3333 16.3336 11.3333C15.8734 11.3333 15.5003 11.7064 15.5003 12.1666C15.5003 12.6268 15.8734 12.9999 16.3336 12.9999Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6664 9.66659C18.2857 9.66659 17.1664 10.7859 17.1664 12.1666C17.1664 12.4588 17.2165 12.7393 17.3086 12.9999H19.6664H22.0241C22.1163 12.7393 22.1664 12.4588 22.1664 12.1666C22.1664 10.7859 21.0471 9.66659 19.6664 9.66659ZM19.6664 12.9999C20.1266 12.9999 20.4997 12.6268 20.4997 12.1666C20.4997 11.7064 20.1266 11.3333 19.6664 11.3333C19.2061 11.3333 18.833 11.7064 18.833 12.1666C18.833 12.6268 19.2061 12.9999 19.6664 12.9999Z",
    fill: "#111111"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrize);
export default __webpack_public_path__ + "static/media/Prize.5b9049ecbff166786682e38f84c4261d.svg";
export { ForwardRef as ReactComponent };